document.addEventListener('DOMContentLoaded', () => {
  function formatMoneyNode(node) {
    if (!(node instanceof HTMLElement)) return;

    const text = node.textContent || '';

    const isCzk = text.includes('Kč');
    const isPln = text.includes('zł');

    if (!isCzk && !isPln) return;

    if (!/\d,\d{2}\s*(Kč|zł)/.test(text) && !node.dataset.price) return;

    const dataPriceCents = node.dataset.priceCents
      ? Number(node.dataset.priceCents)
      : null;

    const dataPrice = node.dataset.price
      ? Number(node.dataset.price)
      : null;

    let cents = null;

    if (Number.isFinite(dataPriceCents)) {
      cents = dataPriceCents;
    } else if (Number.isFinite(dataPrice)) {

      cents = dataPrice;
    }

    if (!Number.isFinite(cents)) {
      const digits = text.replace(/[^\d]/g, '');
      const num = Number(digits);
      if (Number.isFinite(num)) cents = num;
    }

    if (!Number.isFinite(cents)) return;

    let locale = 'cs-CZ';
    let currency = 'CZK';
    let minFrac = 0;
    let maxFrac = 0;

    if (isPln) {
      locale = 'pl-PL';
      currency = 'PLN';

      minFrac = 0;
      maxFrac = 0;
    }

    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: minFrac,
      maximumFractionDigits: maxFrac
    }).format(cents / 100);

    node.textContent = formatted;
  }

  function formatAll(root = document) {

    root
      .querySelectorAll('[ref="priceContainer"]')
      .forEach(formatMoneyNode);

    root
      .querySelectorAll(
        '.ecom-product-single__price-normal, .ecom-product-single__price__sale'
      )
      .forEach(formatMoneyNode);

    root
      .querySelectorAll('.price')
      .forEach(formatMoneyNode);

    root
      .querySelectorAll('.seal-money, .ht-money')
      .forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        const text = (node.textContent || '').trim();

        if (/[€]|zł|PLN|CZK|Kč/.test(text)) return;

        if (!/\d/.test(text)) return;

        node.textContent = `${text} Kč`;
      });
  }

  formatAll(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        formatAll(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});